import {createSinglePathSVG} from './TEMPLATE'

export const InsertLink_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 20 20',
  strokeWidth: 1.67,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M10.5896 15.3033L9.41112 16.4818C7.78394 18.109 5.14575 18.109 3.51857 16.4818C1.89138 14.8546 1.89138 12.2164 3.51857 10.5892L4.69708 9.41072M15.3037 10.5892L16.4822 9.41072C18.1094 7.78353 18.1094 5.14534 16.4822 3.51816C14.855 1.89097 12.2168 1.89097 10.5896 3.51816L9.41112 4.69667M7.08371 12.9166L12.917 7.08329',
})
